module.exports = __webpack_public_path__ + "static/media/logo_brcomerce_branco.71debb69.svg";